export default "/images/vendor/flag-icons/flags/4x3/mp.svg?22db1d8d93210e4b195ecf0066b15a41";